import type { TDashboard } from 'types/hubDashboard.type';
import { z } from 'zod';

const hubDashboardSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name is required' }),
  roles: z
    .array(
      z.string().trim().min(1, { message: 'Role must be a non-empty string' })
    )
    .min(1, {
      message: 'At least one role must be set',
    }),
});

export const validateHubDashboard = (config: Partial<TDashboard>) => {
  return hubDashboardSchema.safeParse(config);
};
